export const businessInfo = {
  name: "A.J. Auto & RV Care",
  phone: "785-498-9007",
  email: "aidenlang8588@gmail.com",
  address: "Mobile service based out of Hays, KS",
  serviceArea: "Mobile service within 50 miles of Hays, KS",
  mileagePolicy: "Mileage may be charged for jobs outside the Hays, KS area.",
};

export const navLinks = [
  { label: "Services", href: "#services", testId: "nav-services-link" },
  { label: "Packages", href: "#pricing", testId: "nav-packages-link" },
  { label: "Booking", href: "#booking", testId: "nav-booking-link" },
  { label: "Gallery", href: "#gallery", testId: "nav-gallery-link" },
  { label: "Reviews", href: "#reviews", testId: "nav-reviews-link" },
  { label: "Contact", href: "#contact", testId: "nav-contact-link" },
];

export const media = {
  hero: "https://static.prod-images.emergentagent.com/jobs/8d23e77f-6a80-42ac-8a6d-9629a2d46216/images/c472d43f004654393a93a5d8df960574f9fd8b8e14a5281939071ae36347177d.png",
  rv: "https://static.prod-images.emergentagent.com/jobs/8d23e77f-6a80-42ac-8a6d-9629a2d46216/images/c8db452f2707298794f9765e4d1b8c7b6d5ba7134efb1fc32c0c05d76ac9b413.png",
  interior: "https://static.prod-images.emergentagent.com/jobs/8d23e77f-6a80-42ac-8a6d-9629a2d46216/images/4aa3df319d5234b1e43e2e8e9c3421d518778608c64a6f09b58a1b052d634e7e.png",
  exterior: "https://images.pexels.com/photos/14231678/pexels-photo-14231678.jpeg",
  diagnostic: "https://static.prod-images.emergentagent.com/jobs/8d23e77f-6a80-42ac-8a6d-9629a2d46216/images/6649c1f5c315aaf9296baeb5dcab5743e4ee084b7b2683c6ccbbd539ca8c15f3.png",
};

export const serviceCards = [
  {
    title: "Interior detailing",
    eyebrow: "Cabin reset",
    description: "A thorough inside clean focused on the areas you actually touch every day. We take care of seats, floors, dash, vents, cupholders, and all the small spots that collect dirt over time in cars, trucks, SUVs, and RV interiors.",
    image: media.interior,
    testId: "service-interior-card",
  },
  {
    title: "Exterior cleaning",
    eyebrow: "Gloss-first wash",
    description: "A proper exterior wash and finish that brings your vehicle back to a clean, maintained look. Built for daily drivers, work vehicles, and larger rigs that need more than a quick rinse.",
    image: media.exterior,
    testId: "service-exterior-card",
  },
  {
    title: "RV care",
    eyebrow: "Oversized detail work",
    description: "Detailed cleaning for both the inside and outside of RVs. We handle everything from lived-in interiors to weather-worn exteriors so your rig stays comfortable, clean, and ready for the road.",
    image: media.rv,
    testId: "service-rv-card",
  },
  {
    title: "Basic mobile maintenance",
    eyebrow: "Mobile vehicle care",
    description: "Simple, on-site vehicle upkeep like oil changes, tire rotations, and basic diagnostics. It’s about keeping your vehicle running right without the hassle of sitting in a shop waiting room.",
    image: media.diagnostic,
    testId: "service-maintenance-card",
  },
];

export const pricingItems = [
  {
    name: "Small",
    price: "From $120",
    note: "Coupes, sedans, and hatchbacks. Estimates only.",
    packages: [
      "Basic — $120 interior detailing",
      "Deluxe — $180 interior + exterior wash with hand-applied wax protection",
      "Premium — $300 interior detailing + exterior wash, gloss-enhancing polish, and hand-applied wax protection",
    ],
    testId: "pricing-small-card",
  },
  {
    name: "Medium",
    price: "From $150",
    note: "Crossovers, 2-row SUVs, and small trucks. Estimates only.",
    packages: [
      "Basic — $150 interior detailing",
      "Deluxe — $220 interior + exterior wash with hand-applied wax protection",
      "Premium — $350 interior detailing + exterior wash, gloss-enhancing polish, and hand-applied wax protection",
    ],
    testId: "pricing-medium-card",
  },
  {
    name: "Large",
    price: "From $180",
    note: "Full-size SUVs, 3-row SUVs, and crew-cab trucks. Estimates only.",
    packages: [
      "Basic — $180 interior detailing",
      "Deluxe — $250 interior + exterior wash with hand-applied wax protection",
      "Premium — $450 interior detailing + exterior wash, gloss-enhancing polish, and hand-applied wax protection",
    ],
    testId: "pricing-large-card",
  },
  {
    name: "XL",
    price: "From $180",
    note: "Heavy-duty trucks, vans, and extended-length SUVs. Estimates only.",
    packages: [
      "Basic — $180 interior detailing",
      "Deluxe — $250 interior + exterior wash with hand-applied wax protection",
      "Premium — $400 interior detailing + exterior wash, gloss-enhancing polish, and hand-applied wax protection",
    ],
    testId: "pricing-xl-card",
  },
  {
    name: "RV and Camper",
    price: "From $250",
    note: "RVs and campers are quoted by size and condition.",
    packages: [
      "Basic — $250 interior detailing",
      "Deluxe — call, text, or email for quote",
      "Premium — call, text, or email for quote",
    ],
    testId: "pricing-rv-card",
  },
  {
    name: "Maintenance services",
    price: "Quote required",
    note: "Tire rotations, code scanning, minor diagnostics, and oil changes.",
    packages: [
      "Oil change — customer supplies oil; labor is quoted",
      "Tire rotations — call, text, or email for quote",
      "Code scan / minor diagnostics — call, text, or email for quote",
    ],
    featured: true,
    testId: "pricing-maintenance-card",
  },
];

export const packageComparison = [
  { level: "Basic", interior: true, wash: false, wax: false, polish: false },
  { level: "Deluxe", interior: true, wash: true, wax: true, polish: false },
  { level: "Premium", interior: true, wash: true, wax: true, polish: true },
];

export const vehicleSizeCategories = [
  { size: "Small", vehicles: "Coupes, sedans, hatchbacks", examples: "Civic, Corolla, Camry" },
  { size: "Medium", vehicles: "Crossovers, 2-row SUVs, small trucks", examples: "CR-V, RAV4, Tacoma" },
  { size: "Large", vehicles: "Full-size SUVs, 3-row SUVs, crew-cab trucks", examples: "F-150, Tahoe, Telluride" },
  { size: "XL", vehicles: "Heavy-duty trucks, vans, extended-length SUVs", examples: "F-250, Suburban, Sprinter Van" },
  { size: "RV and Camper", vehicles: "RV and Camper", examples: "RV and Camper" },
];